/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Starting_ToastInputs */



/**
* | output |
* | --- |
* | "Starting image export..." |
*
* @param {Image_Export_Starting_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_starting_toast = /** @type {((inputs?: Image_Export_Starting_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Starting_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demarrage de l'exportation d'images...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bildexport wird gestartet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio dell'esportazione dell'immagine...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начало экспорта изображения...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando exportación de imagen...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始导出图像...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("画像のエクスポートを開始しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इमेज एक्सपोर्ट शुरू हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando a exportação da imagem...")
	return /** @type {LocalizedString} */ ("Starting image export...")
});